import { useContext } from "react";
import { Nav } from "react-bootstrap";
import { BoxArrowRight } from "react-bootstrap-icons";
import { AuthContext } from "../../lib/contexts/AuthContext";

/**
 * Sign Out nav item — calls AuthContext.logout() on click.
 *
 * Props:
 *  - collapsed  bool — icon-only mode
 */
export function SignOut({ collapsed }) {
  const authContext = useContext(AuthContext);

  const handleClick = (event) => {
    event.preventDefault();
    if (authContext && typeof authContext.logout === "function") {
      authContext.logout();
    }
  };

  return (
    <Nav.Item as="li">
      <a
        href="#sign-out"
        onClick={handleClick}
        className="cp-nav-item nav-link"
        title={collapsed ? "Sign Out" : undefined}
      >
        <span className="cp-nav-item__icon">
          <BoxArrowRight />
        </span>
        {!collapsed && <span className="cp-nav-item__label">Sign Out</span>}
      </a>
    </Nav.Item>
  );
}
